import { useDispatch } from "react-redux";
import { updateCurrentStep } from "../../auth/store/userSlice";
export const useStepTracking = () => {
  const dispatch = useDispatch();
  /**
   * @param {number} stepNumber - The step number (0-indexed)
   */
  const updateStep = (stepNumber) => {
    const stepForBackend = stepNumber + 1;
    dispatch(updateCurrentStep(stepForBackend));
  };

  return {
    updateStep,
  };
};
